import './jquery.mctimepicker';

export default async function mcdatetimepickerInit(languageCode) {
  if (languageCode === 'de') {
    return import('./i18n/jquery-mctimepicker-de');
  }
  if (languageCode === 'en') {
    return import('./i18n/jquery-mctimepicker-en');
  }
  if (languageCode === 'es') {
    return import('./i18n/jquery-mctimepicker-es');
  }
  if (languageCode === 'fr') {
    return import('./i18n/jquery-mctimepicker-fr');
  }
  if (languageCode === 'it') {
    return import('./i18n/jquery-mctimepicker-it');
  }
  if (languageCode === 'ja') {
    return import('./i18n/jquery-mctimepicker-ja');
  }
  if (languageCode === 'pl') {
    return import('./i18n/jquery-mctimepicker-pl');
  }
  if (languageCode === 'tr') {
    return import('./i18n/jquery-mctimepicker-tr');
  }
  if (languageCode === 'us') {
    return import('./i18n/jquery-mctimepicker-us');
  }
  if (languageCode === 'zh') {
    return import('./i18n/jquery-mctimepicker-zh');
  }

  return null;
}
